module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-down-a78a953402fc57afc754725652fdde2f.svg";